jQuery( function ( $ ) {
    'use strict';

    let content_wrapper = jQuery('.site-content');
    let main_content = jQuery('#primary');

    content_wrapper.css('background-size', main_content.offset().left + 'px, 100%');

    $(document).scroll(function () {
        let page_links_wrapper = jQuery('.page-links-wrapper');
        var waypoint = new Waypoint({
            element: document.getElementsByClassName('contact-line'),
            handler: function(direction) {
                if(direction == 'down') {
                    page_links_wrapper.css('visibility', 'hidden');
                } else {
                    page_links_wrapper.css('visibility', 'visible');
                }
            },
            offset: '100%'
        })
    });
    $(".page-links-wrapper").sticky({topSpacing:0});
});